import type { ReactNode } from 'react'

import { cx } from './core/classes.js'

/** Centered empty, blocked, or recoverable state for list and card surfaces. */
export function Empty(props: Empty.Props) {
  const { action, children, className, icon, title } = props

  return (
    <div
      className={cx(
        'flex min-h-[180px] flex-col items-center justify-center gap-[16px] px-[24px] py-[48px] text-center',
        className,
      )}
    >
      {icon && (
        <div
          aria-hidden
          className="flex size-[40px] items-center justify-center rounded-button border border-border bg-secondary text-foreground-secondary [&>svg]:size-[20px]"
        >
          {icon}
        </div>
      )}
      <div className="flex max-w-[384px] flex-col items-center gap-[6px]">
        <p className="font-medium label-15 text-foreground">{title}</p>
        {children && <p className="label-14 text-foreground-secondary">{children}</p>}
      </div>
      {action && (
        <div className="flex flex-wrap items-center justify-center gap-[8px]">{action}</div>
      )}
    </div>
  )
}

export namespace Empty {
  /** Props for {@link Empty}. */
  export type Props = {
    /** Optional action rendered below the message. */
    action?: ReactNode | undefined
    /** Supporting copy. */
    children?: ReactNode | undefined
    /** Additional class names for layout-specific sizing. */
    className?: string | undefined
    /** Decorative icon shown above the title. */
    icon?: ReactNode | undefined
    /** Primary empty-state message. */
    title: ReactNode
  }
}
